"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const validMobileNumber = (value, maxlength = constants_1.DEFAULT_MAX_NUMBER_LENGTH) => {
    const validLength = value.length > constants_1.DEFAULT_MIN_NUMBER_LENGTH && value.length <= maxlength;
    if (validLength) {
        if (constants_1.DIGIT_AR_REGEX.test(value[(value === null || value === void 0 ? void 0 : value.length) - 1]) || constants_1.DIGIT_AR_REGEX.test(value)) {
            return true;
        }
        else if (constants_1.DIGIT_EN_REGEX.test(value[(value === null || value === void 0 ? void 0 : value.length) - 1]) && constants_1.DIGIT_EN_REGEX.test(value)) {
            return true;
        }
    }
    return false;
};
exports.default = validMobileNumber;
